import React from "react";

export const TableHead = (props) => {
  return (
    <tr>
      <th style={{ width: "15%" }} className="f12-500">
        Item ID
      </th>
      {/* className="table-style" */}
      <th style={{ width: "15%" }} className="f12-500">
        {/* <center> */}
        Item Name
        {/* </center> */}
      </th>
      <th style={{ width: "20%" }} className="f12-500 text-center">
        Item
        <br />
        Category
      </th>
      <th style={{ width: "18%" }} className="f12-500">
        Preparation
        <br />
        Time
      </th>
      <th style={{ width: "17%" }} className="f12-500">
        Status
      </th>
      <th style={{ width: "15%" }} className="f12-500">
        Availability
      </th>
    </tr>
  );
};
